module.exports = "/assets/5dec8148281a6ce86f91ef3a1b2f2ce3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/PG.png
// module id = 2839
// module chunks = 0